module.exports = __webpack_public_path__ + "static/media/MB_WAY.cee2d159.jpg";